"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __importDefault(require("../colors"));
var danger = colors_1.default.danger, gray = colors_1.default.gray, primary = colors_1.default.primary, secondary = colors_1.default.secondary, warning = colors_1.default.warning;
var chartOnlyColors = {
    primary: {
        $50: "#78bad4"
    },
    secondary: {
        $60: "#cd78bb"
    },
    green: {
        $50: "#64a70b",
        $60: "#a6d18c"
    },
    warning: {
        $60: "#fcd570"
    },
    orange: {
        $65: "#eca36e",
        $500: "#f78117"
    },
    gray: {
        $40: "#999999"
    }
};
var chartColors = {
    dual: [
        "#0092bc",
        "#009ec5",
        "#4cadce",
        "#99c8dc",
        "#cfe3ec",
        "#e8f2f4",
        "#cccccc",
        "#b2b2b2",
        "#999999",
        "#666666",
        "#4d4d4d",
        "#1a1a1a"
    ],
    multi: [
        primary.$500,
        chartOnlyColors.primary.$50,
        secondary.$500,
        chartOnlyColors.secondary.$60,
        gray.$700,
        chartOnlyColors.gray.$40,
        warning.$500,
        chartOnlyColors.warning.$60,
        chartOnlyColors.orange.$500,
        chartOnlyColors.orange.$65,
        chartOnlyColors.green.$50,
        chartOnlyColors.green.$60,
        danger.$500
    ]
};
exports.default = chartColors;
//# sourceMappingURL=index.js.map